module.exports = __webpack_public_path__ + "static/media/seguros-mundial-street-selected.de5a7704.svg";